const map = {
	"./background.jpg": "./src/patternlab/source/_patterns/00-protons/img/background.jpg",
	"./header.jpg": "./src/patternlab/source/_patterns/00-protons/img/header.jpg",
	"./header1.jpg": "./src/patternlab/source/_patterns/00-protons/img/header1.jpg",
	"./header2.jpg": "./src/patternlab/source/_patterns/00-protons/img/header2.jpg",
	"./header3.jpg": "./src/patternlab/source/_patterns/00-protons/img/header3.jpg"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/patternlab/source/_patterns/00-protons/img sync recursive \\.(%3F:ico%7Cgif%7Cpng%7Cjpg%7Cjpeg%7Csvg)$i";